// extracted by mini-css-extract-plugin
export default {"order-form":"OrderForm_order-form__3O75_"};